(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = this.dataset.autoplaySpeed;
      this.options = {
        type: this.autoplay ? 'loop' : 'slide',
        waitForTransition: false,
        perPage: 3,
        pagination: false,
        padding: { right: '22.399rem' },
        gap: this.closest('.collection-showcase') ? '3.6rem' : '2.4rem',
        breakpoints: {
          1300: {
            perPage: 2
          },
          1023: {
            perPage: 2,
            padding: { right: '5rem' }
          },
          767: {
            perPage: 1,
            padding: { right: '12rem' },
            gap: '1.6rem'
          },
          480: {
            perPage: 1,
            padding: this.closest('.collection-showcase') ? { right: '8.6rem' } : { right: '4rem' },
            gap: '1.6rem',
          },
          370: {
            perPage: 1,
            padding: { right: '3rem' }
          }
        }
      };

      if (this.autoplay) {
        this.options.autoplay = this.autoplay;
        this.options.interval = this.autoplaySpeed;
      }
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('.js-slider')) return;

      this.slider = new Splide(
        this.querySelector('.js-slider'),
        this.options
      ).mount();
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
